// extracted by mini-css-extract-plugin
module.exports = {"large":"nwea-ds-v1-button-large","medium":"nwea-ds-v1-button-medium","small":"nwea-ds-v1-button-small"};